(() => {
  const init = () => document.querySelectorAll('[data-mm-library]').forEach(root => {
    if (root.dataset.libraryReady) return;
    const grid = root.querySelector('[data-mm-library-grid]');
    if (!grid) return;
    root.dataset.libraryReady = 'true';
    const cards = [...grid.querySelectorAll('[data-mm-library-item]')];
    const search = root.querySelector('[data-mm-library-search]');
    const sort = root.querySelector('[data-mm-library-sort]');
    const count = root.querySelector('[data-mm-library-count]');
    const empty = root.querySelector('[data-mm-library-empty]');
    const buttons = [...root.querySelectorAll('[data-mm-library-type]')];
    const requestedKind = new URLSearchParams(location.search).get('post_type');
    let kind = ['guide', 'article'].includes(requestedKind) ? requestedKind : 'all';
    const normalize = value => value.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase();
    const refresh = () => {
      root.querySelectorAll('.mm-library__pagination a').forEach(link => { const url = new URL(link.href); if (kind === 'all') url.searchParams.delete('post_type'); else url.searchParams.set('post_type', kind); link.href = url.href; });
      const words = normalize(search.value.trim()).split(/\s+/).filter(Boolean);
      const ordered = [...cards].sort((a, b) => sort.value === 'title'
        ? a.dataset.title.localeCompare(b.dataset.title, document.documentElement.lang || 'en', { sensitivity: 'base' })
        : (Number(b.dataset.date) - Number(a.dataset.date)) * (sort.value === 'oldest' ? -1 : 1));
      let visible = 0;
      ordered.forEach(card => {
        card.hidden = (kind !== 'all' && card.dataset.kind !== kind) || !words.every(word => normalize(card.dataset.search).includes(word));
        if (!card.hidden) visible++;
        grid.append(card);
      });
      count.textContent = visible === 1 ? count.dataset.one : count.dataset.many.replace('__COUNT__', String(visible));
      empty.hidden = visible !== 0;
    };
    buttons.forEach(button => button.addEventListener('click', () => {
      kind = button.dataset.mmLibraryType;
      buttons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      refresh();
    }));
    search.addEventListener('input', refresh);
    sort.addEventListener('change', refresh);
    root.querySelector('[data-mm-library-clear]').addEventListener('click', () => {
      search.value = '';
      kind = 'all';
      buttons.forEach(item => item.setAttribute('aria-pressed', String(item.dataset.mmLibraryType === 'all')));
      refresh();
      search.focus();
    });
    buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.mmLibraryType === kind)));
    root.querySelector('[data-mm-library-tools]').hidden = false;
    root.querySelector('[data-mm-library-types]').hidden = false;
    refresh();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
